var React = require('react');

function Notes (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.77778 14.2222H9.77778V9.77778H14.2222V1.77778H1.77778V14.2222ZM1.77778 16C1.28889 16 0.87037 15.8259 0.522222 15.4778C0.174074 15.1296 0 14.7111 0 14.2222V1.77778C0 1.28889 0.174074 0.87037 0.522222 0.522222C0.87037 0.174074 1.28889 0 1.77778 0H14.2222C14.7111 0 15.1296 0.174074 15.4778 0.522222C15.8259 0.87037 16 1.28889 16 1.77778V10.6667L10.6667 16H1.77778ZM3.55556 9.77778V8H8V9.77778H3.55556ZM3.55556 6.22222V4.44444H12.4444V6.22222H3.55556Z","fill":"black"}));
}

Notes.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Notes;

Notes.default = Notes;
